






import { Component, Vue, Watch } from "vue-property-decorator";
import router from "@/router";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import { importantNotification, News } from "@/services/notifications";

interface UpdateItem {
  title: string;
  body: string;
  created: string;
}
interface IWidget {
  name: string;
  src?: string;
  code?: string;
  show?: string;
}
@Component
export default class App extends Vue {
  widgets: IWidget[] = [];
  importantNews: News<UpdateItem> = new News(importantNotification);

  get root() {
    return isRoot();
  }

  get companyOwnerInStore() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get employeeRolesInStore() {
    return this.$store.getters.roles;
  }

  get currentEmployeeRoles() {
    let roles: Array<string>;
    const responsibleInStorage = localStorage.getItem("employee");
    if (this.employeeRolesInStore?.length) {
      roles = this.employeeRolesInStore;
    } else {
      roles = responsibleInStorage
        ? JSON.parse(responsibleInStorage).roles
        : undefined;
    }
    return roles;
  }

  rolesIncludes(items: Array<string>) {
    let rolesSame: Array<string> = [];
    this.currentEmployeeRoles.forEach(el => {
      if (items?.includes(el)) {
        rolesSame.push(el);
      }
    });
    if (items?.includes("company_owner") && this.companyOwnerInStore) {
      rolesSame.push("company_owner");
    }
    return rolesSame.length;
  }

  checkRoles() {
    router.beforeResolve((to, from, next) => {
      if (to.name !== "error") {
        if (
          to.meta?.allowedRoles &&
          this.rolesIncludes(to.meta?.allowedRoles) <= 0 &&
          !this.root
        ) {
          next({ name: "error" });
        } else {
          next();
        }
      } else {
        next();
      }
    });
  }

  get currentCompany() {
    return getCurrentCompanyId();
  }
  async fetchWidgets() {
    try {
      const response = await fetch("/widgets/widgets.json");
      const responseWidgets = response?.ok ? await response?.json() : undefined;
      this.widgets =
        responseWidgets && responseWidgets.widgets
          ? [...this.widgets, ...responseWidgets.widgets]
          : [];
    } catch (e) {
      throw new Error(e);
    }
    this.widgets.forEach(el => {
      if (el.show && el.show === "companyOnly") {
        if (!this.currentCompany) return;
      }
      if (el.src) {
        const insertScript = document.createElement("script");

        insertScript.setAttribute("src", el.src);

        document.body.appendChild(insertScript);
      }
      if (el.code) {
        const insertScript = document.createElement("script");
        insertScript.innerHTML = el.code;
        document.body.appendChild(insertScript);
      }
    });
  }

  @Watch("currentCompany")
  checkCompany(current: string, old: string) {
    if (!old && current) {
      this.widgets.forEach(el => {
        if (el.show && el.show === "companyOnly") {
          if (!this.currentCompany) return;
          if (el.src) {
            const insertScript = document.createElement("script");
            insertScript.setAttribute("src", el.src);

            document.body.appendChild(insertScript);
          }
          if (el.code) {
            const insertScript = document.createElement("script");

            insertScript.innerHTML = el.code;
            document.body.appendChild(insertScript);
          }
        }
      });
    }
  }

  async checkEmployee() {
    router.beforeResolve((to, from, next) => {
      let companyInStore = localStorage.getItem("selectedCompany");
      if (to.name !== "error") {
        if (
          to.meta?.onlyForEmployees &&
          !companyInStore &&
          from.name !== "login"
        ) {
          next({ name: "error" });
        } else {
          next();
        }
      } else {
        next();
      }
    });
  }

  stripHtml(html: any) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  async fetchImportantNews() {
    try {
      const res = await this.importantNews.getNews();

      res.forEach(el => {
        this.$bvToast.toast(this.stripHtml(el.body), {
          variant: "warning",
          noAutoHide: true,
          title: el.title
        });
      });
    } catch (e) {
      console.error(e);
    }
  }

  async init() {
    this.$store.commit("SET_SCREEN_WIDTH", window.innerWidth);
    window.addEventListener("resize", () => {
      this.$store.commit("SET_SCREEN_WIDTH", window.innerWidth);
    });
    await this.checkEmployee();
    await this.fetchWidgets();
  }

  mounted() {
    this.init();
    this.fetchImportantNews();
  }
}
